var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 0.333008C3.31998 0.333008 0.333313 3.31967 0.333313 6.99967C0.333313 10.6797 3.31998 13.6663 6.99998 13.6663C10.68 13.6663 13.6666 10.6797 13.6666 6.99967C13.6666 3.31967 10.68 0.333008 6.99998 0.333008ZM6.33331 10.333V6.33301H7.66665V10.333H6.33331ZM6.33331 3.66634V4.99967H7.66665V3.66634H6.33331Z",
    fill: "#0088F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusEvent);
export default __webpack_public_path__ + "static/media/status_event.b8874daa5d57ca38ba5fa2c6b151417d.svg";
export { ForwardRef as ReactComponent };